import { Customer } from '../model/customer.model';

/** The system that owns the master data of a customer. */
export type CustomerMasterDataSource = 'GCDM' | 'RETAIL_CRM';

/**
 * Whether the master data of this customer lives in the NSC Database (GCDM).
 *
 * The single definition behind both directions: {@link CustomerUpdateService} writes there and
 * {@link CustomerLoadService} reads from there. Keeping it in one place is what prevents the
 * pathological combination of writing to GCDM and reading from Retail CRM's mirror.
 *
 * A customer flagged as synced but without a GCID is treated as local: there is no key to read
 * or write with. The caller logs it, so the population stays measurable.
 */
export function ownsMasterDataInGcdm(customer: Pick<Customer, 'inSyncWithDirectSales' | 'gcid'>): boolean {
  return !!customer.inSyncWithDirectSales && !!customer.gcid;
}
